function init() {
  console.log('GA4 init');

  const GA4PropertyId = ENVIRONMENT === 'production' ? 'G-8V4J1MY5HV' : 'G-R767G5RSGD';
  const firstPartyTagging = `, {
    "transport_url": "https://tag.withlocals.com",
    "first_party_collection": true,
    }`;

  console.log('GA4PropertyId', GA4PropertyId);

  const gtagScriptElement = document.createElement('script');
  gtagScriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${GA4PropertyId}&l=ga4Layer`;
  gtagScriptElement.async = true;
  document.head.appendChild(gtagScriptElement);

  const gtagSetupScriptElement = document.createElement('script');
  gtagSetupScriptElement.innerHTML = `
      window.ga4Layer = window.ga4Layer || [];
      function ga4Tag() { ga4Layer.push(arguments); }
      ga4Tag('js', new Date());
      ga4Tag('config', '${GA4PropertyId}'${ ENVIRONMENT === 'production' ? firstPartyTagging : '' });
  `;
  document.head.appendChild(gtagSetupScriptElement);
}

export default {
  init,
};